import mixpanel from 'mixpanel-browser'

import { env } from '@/env'

try {
  if (!env.REACT_APP_MIXPANEL_TOKEN) {
    console.error('Mixpanel token not found')
  } else {
    if (env.REACT_APP_ENV === 'production') {
      mixpanel.init(env.REACT_APP_MIXPANEL_TOKEN, {
        debug: false,
        track_pageview: true,
        persistence: 'localStorage',
        batch_requests: true,
        ip: true,
        secure_cookie: true,
      })
      console.log('Mixpanel initialized successfully')
    }
  }
} catch (error) {
  console.error('Error initializing Mixpanel', error)
}
